module.exports = __webpack_public_path__ + "static/media/bee_friendly.393e0dc6.png";